import script from "./AddMiddleMenuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddMiddleMenuItem.vue?vue&type=script&lang=ts&setup=true"

import "./AddMiddleMenuItem.vue?vue&type=style&index=0&id=fa0dda9e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa0dda9e"]])

export default __exports__